import { useEffect } from "react"
// import { TermsAndCondition, Grid } from "../components"
import { Navbar, Footer } from "../layouts"
import TermsAndConditions from "../components/terms-and-condition"
import { Grid } from "../components"




const TAndC = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
          });
    }, [])

    return (
        <>
        <Navbar/>
        <Grid/>
        <TermsAndConditions/>
        <Footer/>
        </>

    )
}

export default TAndC